import { UrlMatchResult, UrlSegment } from '@angular/router';

export function customProductUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const index = segments.findIndex((seg) => seg.path.toLowerCase() === 'p');

  if (segments.length >= 1 && segments[0].path.includes('/p/')) {
    const productCode = segments[0].path.toString().slice(-18);
    return {
      consumed: segments,
      posParams: { productCode: new UrlSegment(productCode, {}) },
    };
  } else if (segments.length >= 2 && index !== -1) {
    const productCode = segments[index + 1].path;
    return {
      consumed: segments,
      posParams: { productCode: new UrlSegment(productCode, {}) },
    };
  }

  return null;
}
